import { API_BASE } from "./config";

const noStore: RequestInit = { cache: 'no-store' } as any;
const withTs = (url: string) => url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();

export async function getCardForSubdomain(sub: string) {
  const res = await fetch(withTs(`${API_BASE}/api/cards/by-subdomain/${encodeURIComponent(sub)}`), noStore);
  if (!res.ok) throw new Error(`Card not found for ${sub}`);
  return res.json();
}

export async function getCardForCurrentHost() {
  const res = await fetch(withTs(`${API_BASE}/api/cards/me`), noStore);
  if (!res.ok) throw new Error("Card not found");
  return res.json();
}

// Get a card document (internal shape) by username (public endpoint)
export async function getCardByUsername(username: string) {
  const u = String(username || '').trim().toLowerCase();
  if (!u) throw new Error('getCardByUsername: username is required');
  const res = await fetch(withTs(`${API_BASE}/api/cards/u/${encodeURIComponent(u)}`), noStore);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// Update card contact email; optionally set as login email (default false)
export async function updateCardContactEmail(username: string, email: string, opts?: { setAsLoginEmail?: boolean }) {
  const u = String(username || '').trim().toLowerCase();
  const e = String(email || '').trim().toLowerCase();
  if (!u) throw new Error('updateCardContactEmail: username is required');
  if (!e) throw new Error('updateCardContactEmail: email is required');

  let authHeader: Record<string, string> = {};
  if (typeof window !== 'undefined') {
    try {
      const token = localStorage.getItem('dev_admin_token') || localStorage.getItem('owner_token') || '';
      if (token) authHeader = { Authorization: `Bearer ${token}` };
    } catch {}
  }

  const url = `${API_BASE}/api/cards/u/${encodeURIComponent(u)}/contact-email`;
  const res = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeader },
    credentials: 'include',
    body: JSON.stringify({ email: e, setAsLoginEmail: opts?.setAsLoginEmail }),
  });
  const text = await res.text();
  let data: any = {};
  try { data = text ? JSON.parse(text) : {}; } catch { data = { raw: text }; }
  if (!res.ok) {
    const err = new Error(data?.error || data?.message || res.statusText);
    (err as any).status = res.status;
    (err as any).data = data;
    (err as any).url = url;
    throw err;
  }
  return data as { ok: boolean; username: string; email: string; loginEmailUpdated: boolean };
}

// Update card display email (only changes what's shown on the card, not contact/login)
export async function updateCardDisplayEmail(username: string, email: string) {
  const u = String(username || '').trim().toLowerCase();
  const e = String(email || '').trim().toLowerCase();
  if (!u) throw new Error('updateCardDisplayEmail: username is required');
  if (!e) throw new Error('updateCardDisplayEmail: email is required');

  let authHeader: Record<string, string> = {};
  if (typeof window !== 'undefined') {
    try {
      const token = localStorage.getItem('dev_admin_token') || localStorage.getItem('owner_token') || '';
      if (token) authHeader = { Authorization: `Bearer ${token}` };
    } catch {}
  }

  const url = `${API_BASE}/api/cards/u/${encodeURIComponent(u)}/display-email`;
  const res = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeader },
    credentials: 'include',
    body: JSON.stringify({ email: e }),
  });
  const text = await res.text();
  let data: any = {};
  try { data = text ? JSON.parse(text) : {}; } catch { data = { raw: text }; }
  if (!res.ok) {
    const err = new Error(data?.error || data?.message || res.statusText);
    (err as any).status = res.status;
    (err as any).data = data;
    (err as any).url = url;
    throw err;
  }
  return data as { ok: boolean; username: string; displayEmail: string };
}
